import {BaseWidget} from "./BaseWidget";
import * as Formats from "../constants/Formats";
import moment from 'moment'

export class DateTimeFieldWidget extends BaseWidget {
    afterAttach() {
        super.afterAttach();
        let that = this;
        that.dateTimePicker = that.findElement().kendoDateTimePicker({
            change: (e) => that.onEdit(that.readValueFromElement()),
            format: "dd-MM-yyyy hh:mm tt"
        }).data("kendoDateTimePicker");
        that.findElement().on("focus", (e) => {
            this.dateTimePicker.open("date")
        })
    }

    setValueInElement(value) {
        this.dateTimePicker.value(value || null);
    }

    readValueFromElement() {
        let val = this.dateTimePicker.value();
        if (!val)
            return null;
        let date = new moment(val, Formats.DATE_MOMENT_SERVER_FORMAT);
        let format = date.format(Formats.DATE_MOMENT_SERVER_FORMAT);
        return format;
    }

    setEnabled(enabled) {
        this.dateTimePicker.enable(enabled);
    }
}